var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeferredPaymentProductIcon2 = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1836_15478)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7915 23.125V18.5417C34.7915 16.0104 32.7395 13.9583 30.2082 13.9583C27.6769 13.9583 25.6249 16.0104 25.6249 18.5417V23.125H34.7915ZM21.0415 23.125V18.5417C21.0415 13.4791 25.1456 9.375 30.2082 9.375C35.2708 9.375 39.3749 13.4791 39.3749 18.5417V23.125H43.9582C46.4895 23.125 48.5415 25.177 48.5415 27.7083V41.4583C48.5415 46.5209 44.4375 50.625 39.3749 50.625H21.0415C15.9789 50.625 11.8749 46.5209 11.8749 41.4583V27.7083C11.8749 25.177 13.9269 23.125 16.4582 23.125H21.0415ZM25.6249 30C25.6249 31.2657 24.5989 32.2917 23.3332 32.2917C22.0676 32.2917 21.0415 31.2657 21.0415 30C21.0415 28.7343 22.0676 27.7083 23.3332 27.7083C24.5989 27.7083 25.6249 28.7343 25.6249 30ZM37.0832 32.2917C38.3489 32.2917 39.3749 31.2657 39.3749 30C39.3749 28.7343 38.3489 27.7083 37.0832 27.7083C35.8176 27.7083 34.7915 28.7343 34.7915 30C34.7915 31.2657 35.8176 32.2917 37.0832 32.2917Z",
    fill: "url(#paint0_linear_1836_15478)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7913 18.5416L34.7913 23.1249L39.3746 23.1249L39.3746 18.5416C39.3746 13.479 35.2706 9.37494 30.208 9.37494C25.1454 9.37494 21.0413 13.479 21.0413 18.5416L21.0413 23.1249L25.6246 23.1249L25.6246 18.5416C25.6246 16.0103 27.6767 13.9583 30.208 13.9583C32.7393 13.9583 34.7913 16.0103 34.7913 18.5416Z",
    fill: "#009DD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1836_15478",
    x: 9.87488,
    y: 8.37494,
    width: 40.6666,
    height: 45.2501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1836_15478"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1836_15478",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1836_15478",
    x1: 30.2082,
    y1: 9.375,
    x2: 30.2082,
    y2: 50.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#914187"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#009DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3E4CB4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeferredPaymentProductIcon2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/deferred-payment-product-icon_2.bd93ec44.svg";
export { ForwardRef as ReactComponent };